/**
 * Whether the switch row may open or close a feature for the whole fleet.
 *
 * - `release-flag` follows the switch row
 * - `entitlement`  is decided per account, by its grants alone
 */
export type FeatureKind = 'release-flag' | 'entitlement';

/**
 * The `config.key` whose `settings` jsonb holds each feature's kind:
 *
 * ```json
 * { "cloudflare-beta": "release-flag" }
 * ```
 */
export const FEATURE_KINDS_CONFIG_KEY = 'feature_kinds';

export type FeatureKinds = Readonly<Record<string, FeatureKind>>;

export const DEFAULT_FEATURE_KIND: FeatureKind = 'entitlement';

function isReleaseFlag(value: unknown): value is 'release-flag' {
  return value === 'release-flag';
}

export function parseFeatureKinds(value: unknown): FeatureKinds {
  const parsed: Record<string, FeatureKind> = Object.create(null);

  if (typeof value !== 'object' || value === null) {
    return parsed;
  }

  for (const [flag, kind] of Object.entries(value)) {
    if (isReleaseFlag(kind)) {
      parsed[flag] = kind;
    }
  }

  return parsed;
}

export function kindFor(kinds: FeatureKinds | null | undefined, flag: string): FeatureKind {
  return kinds?.[flag] ?? DEFAULT_FEATURE_KIND;
}
